import styled from "styled-components";

export const Label = styled.label`
  color: rgb(41, 43, 48);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;